import { render, staticRenderFns } from "./MoiteBaranja.vue?vue&type=template&id=4fbf8b76&scoped=true"
import script from "./MoiteBaranja.vue?vue&type=script&lang=js"
export * from "./MoiteBaranja.vue?vue&type=script&lang=js"
import style0 from "./MoiteBaranja.vue?vue&type=style&index=0&id=4fbf8b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf8b76",
  null
  
)

export default component.exports